var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPanel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,20 C1.44771525,20 1,19.5522847 1,19 L1,2 C1,1.44771525 1.44771525,1 2,1 L19,1 C19.5522847,1 20,1.44771525 20,2 L20,19 C20,19.5522847 19.5522847,20 19,20 L2,20 Z M9,4 L9,17 L17,17 L17,4 L9,4 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "10 7 10 8 16 8 16 7"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "10 9 10 10 16 10 16 9"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "10 11 10 12 16 12 16 11"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "10 13 10 14 16 14 16 13"
}))));
export default SvgPanel;